import { render, staticRenderFns } from "./DrawingSlider.vue?vue&type=template&id=1bf5d734&scoped=true"
import script from "./DrawingSlider.vue?vue&type=script&lang=js"
export * from "./DrawingSlider.vue?vue&type=script&lang=js"
import style0 from "./DrawingSlider.vue?vue&type=style&index=0&id=1bf5d734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5d734",
  null
  
)

export default component.exports